<div class="flex p-2" *ngIf="trailerStatus$ | async as trailerStatus; else loading">
  <div class="w-full lg:w-1/4 border border-gray-400 rounded p-1">
    <div class="text-xl underline">What the driver sees</div>
    <div class="py-1" *ngFor="let trailer of trailerStatus.availableTrailers; trackBy: 'trailerId' | trackByKey">
      <span class="text-xl bold text-gray-800">{{ trailer.trailerName }}</span>
      <span class="text-gray-700"> ({{ trailer.trailerId }})</span>
    </div>
  </div>
  <div class="flex-1 ml-2 border border-gray-400 rounded p-1">
    <div class="text-xl underline">All Trailers</div>
    <div class="py-1" *ngFor="let trailer of trailerStatus.allTrailers; trackBy: 'trailerId' | trackByKey">
      <ng-container *ngIf="trailer.availableToDriver">✅ </ng-container>
      <span class="text-xl bold text-gray-800">{{ trailer.trailerName }}</span>
      <span class="text-xl bold text-gray-800"> ({{ trailer.ownershipType }})</span>
      <span class="text-gray-700"> ({{ trailer.trailerId }})</span>
      <ng-container *ngIf="trailer.agnusStatus as status">
        <span class="text-red-500" *ngIf="status.archivedAt"> Deleted at {{ status.archivedAt | standardDate }}</span>
        <span class="text-blue-500" *ngIf="status.orderId"> On Order {{ status.orderID }} ({{ status.userName }})</span>
        <div class="text-gray-600">Agnus Name: {{ status.trailerName }}</div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #loading>
  <div class="flex justify-center">
    <mat-spinner></mat-spinner>
  </div>
</ng-template>
